import locale_text from './locale/text';

export function getParamByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export function getText(text) {
    let locale = getParamByName('lang') || 'he';

    return locale_text[locale] ? locale_text[locale][text] : locale_text.fr[text];
}
export function getLang() {
    return getParamByName('lang') || 'he'
}


// WEBPACK FOOTER //
// ./src/config.js